import { useAuthContext } from "@auth/context/Auth.context";
import type { RolesType } from "@auth/context/Auth.provider";
import DangerZones from "@pages/DangerZones/DangerZones.page";
import Dashboard from "@pages/Dashboard/Dashboard.page";
import DelayManagement from "@pages/DelayManagement/DelayManagement.page";
import Login from "@pages/Login/Login.page";
import ManagementReport from "@pages/ManagementReport/ManagementReport.page";
import ProcessesForm from "@pages/Processes/Form/ProcessesForm.page";
import ProcessesList from "@pages/Processes/List/ProcessesList.page";
import Breadcrumb from "@routes/components/Breadcrumb/Breadcrumb.component";
import Layout from "@template/Layout";
import { Navigate, Route, Routes } from "react-router-dom";

const ROLES: RolesType[] = ["admin", "timeline-manager"];

const AppRoutes: React.FC = () => {
  const { authenticated } = useAuthContext();

  return (
    <Routes>
      <Route
        path="/login"
        element={authenticated ? <Navigate to="/" replace /> : <Login />}
      />

      <Route
        path="/"
        element={authenticated ? <Layout /> : <Navigate to="/login" replace />}
      >
        <Route index element={<Dashboard />} />

        <Route path="/processes" element={<Breadcrumb />}>
          <Route index element={<ProcessesList roles={ROLES} />} />
          <Route path="new" element={<ProcessesForm roles={ROLES} />} />
          <Route path="edit/:id" element={<ProcessesForm roles={ROLES} />} />
        </Route>

        <Route path="/danger-zones" element={<Breadcrumb />}>
          <Route index element={<DangerZones roles={ROLES} />} />
        </Route>

        <Route path="/management-report" element={<Breadcrumb />}>
          <Route index element={<ManagementReport roles={ROLES} />} />
        </Route>

        <Route path="/delay-management" element={<Breadcrumb />}>
          <Route index element={<DelayManagement roles={ROLES} />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
